/**
 *
 * This file was automatically generated using build-icons npm script and should not be edited
 *
 **/
import { createIcon } from "@cmp-src/icons/create-icon";
export const CheckLargeIcon = createIcon({
  displayName: "CheckLargeIcon",
  viewBox: "0 0 16 16",
  path: (
    <g fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.2786 5.52919L7.98836 11.8216C7.30488 12.5054 6.19644 12.5054 5.51297 11.8216L1.72168 8.02919L2.78256 6.96875L6.57385 10.7612C6.67149 10.8589 6.82984 10.8589 6.92748 10.7612L13.2177 4.46875L14.2786 5.52919Z"
        fill="currentColor"
      />
    </g>
  )
});
